import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'AmountPipe',
})
export class AmountPipe implements PipeTransform {
    constructor() {}

    transform(value: number, alwaysShowChange: boolean = true): string {
        if (value === null) {
            return ''
        }
        value = value || 0
        value = Math.round(value * 100) / 100
        let formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
            .format(value || 0)
            .replace(/^\$/, '')
        if (!alwaysShowChange) {
            formatted = formatted.replace(/\.00$/, '')
        }
        return formatted
    }
}
